module.exports = __webpack_public_path__ + "static/media/DTSA-25-ICONS-20.ac3b840d.png";